import { defineStore } from 'pinia'

const STORAGE_KEY = 'messagesHistory'

function loadFromStorage() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return []
    const arr = JSON.parse(raw)
    if (Array.isArray(arr)) return arr
    return []
  } catch {
    return []
  }
}

function saveToStorage(list) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list))
  } catch {}
}

export const useNotificationsStore = defineStore('notifications', {
  state: () => ({
    messages: loadFromStorage(),
  }),
  getters: {
    messagesSorted(state) {
      return [...state.messages].sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0))
    }
  },
  actions: {
    reload() {
      this.messages = loadFromStorage()
    },
    addMessage({ title = 'SnowFuze', body = '', messageId = null, timestamp = Date.now() } = {}) {
      // Deduplicate by messageId+body if possible
      const id = messageId || `${timestamp}-${Math.random().toString(36).slice(2, 8)}`
      const existingIdx = this.messages.findIndex(m => (m.messageId && messageId && String(m.messageId) === String(messageId)) || (m.body === body && m.title === title))
      if (existingIdx >= 0) {
        // Update timestamp on existing
        this.messages[existingIdx] = { ...this.messages[existingIdx], timestamp }
      } else {
        this.messages.push({ id, title, body, messageId, timestamp })
      }
      saveToStorage(this.messages)
    },
    deleteMessage(id) {
      this.messages = this.messages.filter(m => m.id !== id)
      saveToStorage(this.messages)
    },
    clearAll() {
      this.messages = []
      saveToStorage(this.messages)
    }
  }
})
